module.exports = __webpack_public_path__ + "img/dengweiqin.f9ff631d.jpg";